export {
  signInWithToken,
  onIdTokenChanged,
  signOut as firebaseSignOut,
  type FirebaseUser,
} from './auth'

export {
  FirebaseDatabase,
  type Database,
  type Unsubscribe,
} from './database/database'
export { isSuccess, isError, type FirebaseList } from './database/util'
export type { Filter as FirebaseFilter } from './database/filter'

export { database as clientDatabase } from './client-app'
